import { useState } from "react";
import { motion } from "framer-motion";

import { AppWrap } from "./../../HOC/AppWrap";
import images from "../../../constants/images";

import "./Header.scss";

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: "easeInOut",
    },
  },
};

const Header = () => {
  const [mainlenguajes] = useState([images.redux, images.sass, images.react]);

  return (
    <div className="app__header app__flex">
      <motion.div
        whileInView={{ x: [-100, 0], opacity: [0, 1] }}
        transition={{ duration: 0.5 }}
        className="app__header-info"
      >
        <div className="app__header-badge">
          <div className="badge-cmp app__flex app__whitebg">
            <span>👋</span>
            <div style={{ marginLeft: 20 }}>
              <p className="p-text">Hola, soy</p>
              <h1 className="head-text">Emanuel</h1>
            </div>
          </div>

          <div className="tag-cmp app__flex app__whitebg">
            <p className="p-text">Desarrollador de Software</p>
            <p className="p-text">Freelancer</p>
          </div>
        </div>
      </motion.div>

      {/* <motion.div
        className="app__header-circles"
        style={{
          justifyContent: "flex-end",
          alignItems: "center",
          padding: "2rem 0",
          marginLeft: 0,
        }}
      >
        <div className="circle-cmp app__flex">
          <img src={mainlenguajes[3]} alt="cirlce" />
        </div>
      </motion.div> */}

      <motion.div
        variants={scaleVariants}
        whileInView={scaleVariants.whileInView}
        className="app__header-circles"
      >
        {mainlenguajes.map((item, index) => (
          <>
            <div key={index} className="circle-cmp app__flex">
              <img src={item} alt="cirlce" />
            </div>
          </>
        ))}
      </motion.div>
    </div>
  );
};

export default AppWrap(Header, "home");
